import { render, staticRenderFns } from "./BusinessList.vue?vue&type=template&id=dce09b06&scoped=true"
import script from "./BusinessList.vue?vue&type=script&lang=js"
export * from "./BusinessList.vue?vue&type=script&lang=js"
import style0 from "./BusinessList.vue?vue&type=style&index=0&id=dce09b06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_29ccf6a1548590c1291b44f0faebdb79/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dce09b06",
  null
  
)

export default component.exports